import { MetaRoot } from 'util/metaPath'

import { createCpfCnsCalculation, createDescricaoCalculation } from '../calculator-atestadoCommon'
import AtestadoModel, { CidadaoAtestado } from '../components/model-atestado'
import { getAtestadoPadraoText } from './utils-atestadoPadrao'

export const createAtestadoPadraoCalculations = (
  path: MetaRoot<AtestadoModel>,
  cidadao: CidadaoAtestado,
  nomeUnidadeSaude: string
) => [
  createCpfCnsCalculation(path),
  createDescricaoCalculation(
    path,
    [
      path.data.absolutePath(),
      path.hora.absolutePath(),
      path.dias.absolutePath(),
      path.cid10.absolutePath(),
      path.cpfCns.absolutePath(),
      path.naoPossui.absolutePath(),
    ],
    (values) => getAtestadoPadraoText({ cidadao, nomeUnidadeSaude, values })
  ),
]
